import React from 'react';
import { Controller, ControllerProps, FieldValues, FieldPath, Control } from 'react-hook-form';
import { renderChildren } from '@fiverr-private/ui_utils';
import { Stack } from '@fiverr-private/layout_components';
import { FORM_ELEMENT_ID } from '../constants';
import { useFormContext } from '../FormContext';

type FormElementControllerProps<T extends FieldValues, TName extends FieldPath<T>> = Omit<
  ControllerProps<T, TName>,
  'control' | 'name'
>;

const FormElementController = <T extends FieldValues = FieldValues, TName extends FieldPath<T> = FieldPath<T>>({
  render,
  ...restProps
}: FormElementControllerProps<T, TName>) => {
  const { isError, isSuccess, name, control } = useFormContext();

  return (
    <Stack direction="column" gap="2">
      <Controller<T, TName>
        control={control as Control<T>}
        render={(props) => renderChildren(render(props), { isSuccess, isError, ...restProps })}
        name={name as TName}
      />
    </Stack>
  );
};
FormElementController.displayName = FORM_ELEMENT_ID;
Object.assign(FormElementController, {
  id: FORM_ELEMENT_ID,
});

export default FormElementController;
